import { useEffect, useRef, useState } from "react";

const useCountdown = (
    start,
    quarterSelected,
    details,
    setDetails,
    timeExpiredHandler
) => {
    const firstStart = useRef(true);
    const timeExpired = useRef(false);
    const tick = useRef();

    useEffect(() => {
        if (firstStart.current) {
            firstStart.current = !firstStart.current;
            return;
        }

        if (!start && !firstStart.current && timeExpired.current) {
            if (details[quarterSelected]?.timeLeft <= 0) {
                timeExpiredHandler();
            }
        }

        if (start) {
            tick.current = setInterval(() => {
                setDetails((details) => {
                    if (details[quarterSelected]?.timeLeft <= 0) {
                        clearInterval(tick.current);
                        timeExpired.current = true;
                        return {
                            ...details,
                            [quarterSelected]: {
                                ...details[quarterSelected],
                                quarterStopped: true,
                                quarterStarted: false,
                                quarterEnded: false,
                            },
                        };
                    }
                    return {
                        ...details,
                        [quarterSelected]: {
                            ...details[quarterSelected],
                            timeLeft: details[quarterSelected]["timeLeft"] - 1,
                            timePlayed:
                                details[quarterSelected]["timePlayed"] + 1,
                        },
                    };
                });
            }, 1000);
        } else {
            clearInterval(tick.current);
        }

        return () => clearInterval(tick.current);
    }, [quarterSelected, setDetails, start]);

    return { changeSecondsToString };
};

const changeSecondsToString = (type, seconds) => {
    // 25:00

    const mins = Math.floor(seconds / 60);
    const seconds_ = seconds % 60;

    //   console.log({ type, seconds, mins, seconds_ });
    return (
        (mins === 0 ? "00" : mins < 10 ? `0${mins}` : mins.toString()) +
        ":" +
        (seconds_ === 0
            ? "00"
            : seconds_ < 10
            ? `0${seconds_}`
            : seconds_.toString())
    );
};

const changeSecondsToMinsAndSeconds = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return { mins, secs };
};

export { useCountdown, changeSecondsToString, changeSecondsToMinsAndSeconds };
